import axios from 'axios';
import { API, ApiKey } from '../config';
const headerAPI = { ApiKey: `${ApiKey}`};

export const getRecipe = (id) => {
  return axios.get(`${API}/api/recipes/${id}`, { headers: headerAPI });
};
